/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentAuditResponse } from './equipment-audit-response';


export interface EquipmentAuditResponsePagedList { 
    totalCount?: number;
    items?: Array<EquipmentAuditResponse> | null;
}

